import errorsMessage from 'App/Services/Localizations/formErrors/errorsMessage';
import { LP_FAIL_SUFFIX } from 'App/Services/Sharpstar/sharpStarConstants';

export const errorList = (defaultUrl, lang) => {
    return {
        undefined: errorObject(
            null,
            true,
            `${defaultUrl}${LP_FAIL_SUFFIX.shar}`
        ),
        10: errorObject(
            errorsMessage.t(`${lang}.name_validation_failed`),
            false,
            null
        ),
        11: errorObject(
            errorsMessage.t(`${lang}.email_address_exists_error`),
            false,
            null
        ),
        12: errorObject(null, true, 'https://www.1800gambler.net'),
        20: errorObject(null, true, defaultUrl),
        21: errorObject(null, true, defaultUrl),
        22: errorObject(null, true, defaultUrl),
        23: errorObject(null, true, defaultUrl),
        24: errorObject(
            errorsMessage.t(`${lang}.recaptcha_failed`),
            false,
            null
        ),
        25: errorObject(
            errorsMessage.t(`${lang}.something_went_wrong`),
            false,
            null
        ),
        30: errorObject(null, false, defaultUrl),
        40: errorObject(null, true, `${defaultUrl}${LP_FAIL_SUFFIX.reg}`),
        41: errorObject(
            errorsMessage.t(`${lang}.invalid_email_reason_unknown`),
            false,
            null
        ),
        42: errorObject(
            errorsMessage.t(`${lang}.invalid_email_role`),
            false,
            null
        ),
        43: errorObject(
            errorsMessage.t(`${lang}.invalid_email_disposable`),
            false,
            null
        ),
        44: errorObject(
            errorsMessage.t(`${lang}.invalid_email_reason_rejected`),
            false,
            null
        ),
        45: errorObject(
            (message) =>
                errorsMessage.t(`${lang}.invalid_email_w_suggestion`, {
                    suggestion: message,
                }),
            false,
            null
        ),
        50: errorObject(null, false, null),
        51: errorObject(null, false, null),
        52: errorObject(null, false, null),
        53: errorObject(null, false, null),
        60: errorObject(null, true, `${defaultUrl}${LP_FAIL_SUFFIX.reg}`),
    };
};

function errorObject(errorMessage, redirect, redirectType) {
    return {
        errorMessage,
        redirect,
        redirectType,
    };
}
